let AdobeAn;
let exportRoot;
import createjs from 'createjs';
/* eslint-disable camelcase */
(function(cjs, an) {
    let p; // shortcut to reference prototypes
    const lib = {};
    const ss = {};
    const img = {};
    lib.ssMetadata = [];

    // symbols:
    // helper functions:

    function mc_symbol_clone() {
        const clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
    }

    function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        const prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
    }

    (lib.Symbol1 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#E7E7E7')
            .s()
            .p('Am9CYIACswIN5IBIgDMxgABYD/ICyBoIABmZIiyhmg');
        this.shape.setTransform(-3.6, 2);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#FFFFFF')
            .s()
            .p('AngjsIBIgoIN4IBIhHAog');
        this.shape_1.setTransform(0.1, -40.9);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({state: [{t: this.shape_1}, {t: this.shape}]})
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol1, new cjs.Rectangle(-48.1, -68.5, 96.3, 137.1), null);

    // stage content:
    (lib._2 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_2
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#9AA5C0')
            .s()
            .p('AgfuCIBEgqIgFcvIhEAqg');
        this.shape.setTransform(163.8, 186.3);

        this.timeline.addTween(cjs.Tween.get(this.shape).wait(69));

        // Layer_3
        this.instance = new lib.Symbol1();
        this.instance.parent = this;
        this.instance.setTransform(66, 78.7);

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .to({x: 101.9, y: 99.3}, 8, cjs.Ease.quintInOut)
                .to({x: 66, y: 78.7}, 27, cjs.Ease.quadInOut)
                .wait(34)
        );

        // Layer_5
        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#E7E7E7')
            .s()
            .p('AtCm6IBFgnIZAOZIhFAqg');
        this.shape_1.setTransform(84, 48.2);

        this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(69));

        // Layer_6
        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#FFFFFF')
            .s()
            .p('ApukAIABjNITcLOIgBDNg');
        this.shape_2.setTransform(80.1, 223.9);

        this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(69));

        // Layer_7
        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .f('#E7E7E7')
            .s()
            .p('Apug0IABplITcLOIgCJlg');
        this.shape_3.setTransform(80.2, 183);

        this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(69));

        // Layer_8
        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .f('#B9C4E3')
            .s()
            .p('AsiHJIAF8uIZAOcIgFcvg');
        this.shape_4.setTransform(80.3, 142.2);

        this.timeline.addTween(cjs.Tween.get(this.shape_4).wait(69));
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(84, 141, 167.5, 280.4);
    // library properties:
    lib.properties = {
        id: 'FDC74496180246FA98A0EFCB50C51217',
        width: 168,
        height: 282,
        fps: 24,
        color: '#CCCCCC',
        opacity: 0.0,
        manifest: [],
        preloads: []
    };

    // bootstrap callback support:

    (lib.Stage = function(canvas) {
        createjs.Stage.call(this, canvas);
    }).prototype = p = new createjs.Stage();

    p.setAutoPlay = function(autoPlay) {
        this.tickEnabled = autoPlay;
    };
    p.play = function() {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
    };
    p.stop = function(ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
    };
    p.seek = function(ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
    };
    p.getDuration = function() {
        return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
    };

    p.getTimelinePosition = function() {
        return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
    };

    an.bootcompsLoaded = an.bootcompsLoaded || [];
    if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
    }

    an.bootstrapCallback = function(fnCallback) {
        an.bootstrapListeners.push(fnCallback);
        if (an.bootcompsLoaded.length > 0) {
            for (let i = 0; i < an.bootcompsLoaded.length; ++i) {
                fnCallback(an.bootcompsLoaded[i]);
            }
        }
    };

    an.compositions = an.compositions || {};
    an.compositions['FDC74496180246FA98A0EFCB50C51217'] = {
        getStage: function() {
            return exportRoot.getStage();
        },
        getLibrary: function() {
            return lib;
        },
        getSpriteSheet: function() {
            return ss;
        },
        getImages: function() {
            return img;
        }
    };

    an.compositionLoaded = function(id) {
        an.bootcompsLoaded.push(id);
        for (let j = 0; j < an.bootstrapListeners.length; j++) {
            an.bootstrapListeners[j](id);
        }
    };

    an.getComposition = function(id) {
        return an.compositions[id];
    };
})((createjs = createjs || {}), (AdobeAn = AdobeAn || {}));

const composition = AdobeAn.getComposition('FDC74496180246FA98A0EFCB50C51217');

export {AdobeAn};
export {composition};
